import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskLines = ({ lines, className = "", delay = 0.15, lineClass = "" }) => (
  <span className={className}>
    {lines.map((l, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span
          className={`block ${lineClass} ${typeof l === "object" ? l.className : ""}`}
          initial={{ y: "108%", rotate: 2 }}
          animate={{ y: "0%", rotate: 0 }}
          transition={{ duration: 1.1, ease: EASE, delay: delay + i * 0.13 }}
        >
          {typeof l === "object" ? l.text : l}
        </motion.span>
      </span>
    ))}
  </span>
);

export const SectionLabel = ({ index, children }) => (
  <div className="flex items-center gap-4">
    <span className="font-mono text-xs text-[var(--gold)]">{index}</span>
    <span className="h-px w-10 bg-white/20" />
    <span className="eyebrow">{children}</span>
  </div>
);
